/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES 
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/frames/frame_styles';
import { createStyles } from 'utils/styles';
const { classes } = createStyles(styles);



/* ========== ~~~~~~~~~~ FRAME : CHILD ~~~~~~~~~~ ========== */
class Frame extends Component {
    constructor(props) {
        super(props);
        this.timer = null;
    }

    /* <<<<<<<<<< LIFECYCLE FUNCTIONS >>>>>>>>>> */
    componentWillReceiveProps(nextProps) {
        this.handleTimedFrame(nextProps);
    }
    componentWillUnmount() {
        clearTimeout(this.timer); // !!! double check that this timer is cleared at appropriate times (also in handleTimedFrame)
    }

    /* >>>>>>>>>> CUSTOM FUNCTIONS <<<<<<<<<< */
    isActiveFrame(props=this.props) {
        return props.frameIndex === props.currentContentStatus['frame'];
    }
    isTimedFrame() {
        return this.props.currentContentStatus['showFrameForXSeconds'] !== null ? true : false;
    }
    isPausedContent(passedProps = this.props) {
        return passedProps.currentContentStatus['paused'] ? true : false;
    }
    handleActiveClass() {
        return this.isActiveFrame() ? 'active' : 'inactive';
    }
    isClearTimeoutRequested(props=this.props) {
        return props.currentContentStatus.clearTimeout && this.isActiveFrame();
    }
    isComponentDeactivating(nextProps) {
        return this.isActiveFrame() && !this.isActiveFrame(nextProps);
    }
    handleTimedFrame(nextProps) {
        if(this.props.currentContentStatus.type === 'summary') { return null; }
        // if we'll be an active frame that is on a timer and we're not paused content then create a timeout based on seconds alloted from settings file property that will advance the frame
        // may need to move this to an action/reducer
        if ((this.isActiveFrame(nextProps)) && this.isTimedFrame() && !this.isPausedContent(nextProps) && this.timer === null) {
            this.timer = setTimeout(() => {
              this.props.advanceFrame(this.props.contentId);
            }, this.props.currentContentStatus['showFrameForXSeconds']);
        }
        if(this.isTimedFrame() && (this.isComponentDeactivating(nextProps) || this.isClearTimeoutRequested(nextProps))) {
            clearTimeout(this.timer);
        }
    }
    shouldShowProgressBar() {
        return this.props.currentContentStatus.showFrameForXSeconds !== null &&
                this.props.currentContentStatus.type === 'quiz' &&
                this.props.currentContentStatus.uniqueState.frameStatus[this.props.frameIndex] === 'unanswered'
    }

    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        if (!this.isActiveFrame()) { return null; }
        return(
            <div className={`${classes.frame} frame type-${this.props.type}`}>
                {this.props.markup}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default Frame;